<template>
  <div>
    <b-container fluid>
      <h3 class="mt-3 mb-3">SKU Master</h3>

      <div class="search_bar mb-3"
        v-if="checkPermission($store.state.user_obj, 'Controls', 'SKU Master', 'Upload SKU Master', true)">
        <b-row>
          <b-col cols="4" class="pr-1">
            <b-form-file v-model="upload_file" placeholder="Choose a file..." size="sm"></b-form-file>
          </b-col>

          <b-col class="text-left p-0">
            <b-button class="btn-action" size="sm" variant="info" @click="onUploadFile">Upload</b-button>
          </b-col>
        </b-row>
      </div>

      <div class="search_bar mb-3"
        v-if="$store.state.user_obj.client_id == '86' || $store.state.user_obj.client_id == '110' || $store.state.user_obj.client_id == '114'">
        <b-row>
          <b-col cols="4" class="pr-1">
            <b-form-file v-model="upload_file_serial" placeholder="Choose a file..." size="sm"></b-form-file>
          </b-col>

          <b-col class="text-left p-0">
            <b-button class="btn-action" size="sm" variant="info" @click="onUploadFile_serial">Upload Product
              Serial</b-button>
          </b-col>
        </b-row>
      </div>

      <div class="search_bar mb-3"
        v-if="$store.state.user_obj.client_id == '86' || $store.state.user_obj.client_id == '110' || $store.state.user_obj.client_id == '114'">
        <b-row>
          <b-col cols="4" class="pr-1">
            <b-form-file v-model="upload_file_bulk_fulfil_serial" placeholder="Choose a file..."
              size="sm"></b-form-file>
          </b-col>

          <b-col class="text-left p-0">
            <b-button class="btn-action" size="sm" variant="info" @click="onUploadFile_bulk_fulfil_serial">Bulk Fulfil
              Product Serial </b-button>
          </b-col>
        </b-row>
      </div>

      <div class="search_bar mb-3">
        <b-row>
          <b-col cols="2" class="pr-1">
            <b-form-select size="sm" v-model="search_criteria.channel_selected" :options="channel_options" />
          </b-col>
          <b-col cols="4" class="pr-1">
            <b-form-input id="input-small" size="sm" type="text" placeholder="Product SKU / Channel SKU / Other SKU"
              v-model="search_criteria.keyword"></b-form-input>
          </b-col>
          <b-col class="text-left p-0">
            <b-button class="btn-action" size="sm" variant="info" @click="onSearch">
              <font-awesome-icon class="mr-1" icon="search" />Search
            </b-button>

            <b-button class="btn-action" size="sm" variant="info" @click="onExport">
              <font-awesome-icon class="mr-1" icon="search" />Export SKU Master
            </b-button>

            <b-button class="btn-action" size="sm" variant="info" @click="onExportClientSKUMaster">
              <font-awesome-icon class="mr-1" icon="search" />Export Client SKU Master
            </b-button>
          </b-col>
        </b-row>
      </div>

      <b-pagination size="sm" :total-rows="total_rows" v-model="currentPage" :per-page="TABLE_LIMIT"
        @change="onPageChange" :limit="PAGING_LIMIT"></b-pagination>

      <b-table responsive small outlined striped hover sticky-header="500px" :items="items" :fields="fields">
        <template v-slot:head(chk_box)="data">
          <b-form-checkbox size="sm" plain id="chkbox_all" value="all" v-model="check_all_rows"></b-form-checkbox>
        </template>
        <template v-slot:cell(chk_box)="data">
          <b-form-checkbox size="sm" class="chkbox_row" plain :id="'chkbox_row_' + data.index"
            v-model="data.item.is_checked"></b-form-checkbox>
        </template>
        <template v-slot:cell(cover_image)="data">
          <img :src="data.item.cover_image" width="50">
        </template>

        <template v-slot:cell(vendor)="data">
          {{ data.item.vendor || "-" }}
        </template>

        <template v-slot:cell(brand)="data">
          {{ data.item.brand || "-" }}
        </template>
        <template v-slot:cell(action)="data">
          <b-button class="btn-action" size="sm" variant="info" :to="{
            name: 'product_master_edit',
            params: { id: data.item.id }
          }" @click="doReceiveOrder(data.item)">Edit</b-button>

          <b-button v-if="$store.state.user_obj &&
            checkPermission(
              $store.state.user_obj,
              'Controls',
              'SKU Master',
              'Clone',
              $store.state.user_obj.permissions.funct_product_clone
            )" class="btn-action" size="sm" variant="info" :to="{
              name: 'product_master_clone',
              params: { id: data.item.id }
            }">Clone</b-button>
        </template>
      </b-table>

      <b-pagination size="sm" :total-rows="total_rows" v-model="currentPage" :per-page="TABLE_LIMIT"
        @change="onPageChange" :limit="PAGING_LIMIT"></b-pagination>
    </b-container>
  </div>
</template>

<script>
import moment from "moment";
import VueBarcode from "vue-barcode";

const fields_old = [
  {
    key: "chk_box",
    label: ""
  },
  // {
  //   key: "client",
  //   label: "client"
  // },
  {
    key: "channel",
    label: "channel"
  },
  {
    key: "primary_category",
    label: "primary_category"
  },
  {
    key: "primary_sub_category",
    label: "primary_sub_category"
  },
  {
    key: "secondary_category",
    label: "secondary_category"
  },
  {
    key: "secondary_sub_category",
    label: "secondary_sub_category"
  },
  {
    key: "variant",
    label: "variant"
  },
  {
    key: "variance_en",
    label: "variance_en"
  },
  {
    key: "var_description_en",
    label: "var_description_en"
  },
  {
    key: "variance_ch",
    label: "variance_ch"
  },
  {
    key: "var_description_ch",
    label: "var_description_ch"
  },
  {
    key: "product_sku",
    label: "product_sku"
  },
  {
    key: "channel_sku",
    label: "channel_sku"
  },
  {
    key: "other_sku",
    label: "other_sku"
  },
  {
    key: "lot_1",
    label: "lot_1"
  },
  {
    key: "lot_2",
    label: "lot_2"
  },
  {
    key: "vendor",
    label: "vendor"
  },
  {
    key: "brand",
    label: "brand"
  },
  {
    key: "product_description_en_int",
    label: "product_description_en_int"
  },
  {
    key: "product_description_en_ext",
    label: "product_description_en_ext"
  },
  {
    key: "product_description_en",
    label: "product_description_en"
  },
  {
    key: "product_description_cn_int",
    label: "product_description_cn_int"
  },
  {
    key: "product_description_cn_ext",
    label: "product_description_cn_ext"
  },
  {
    key: "product_description_cn",
    label: "product_description_cn"
  },
  {
    key: "height_cm",
    label: "height_cm"
  },
  {
    key: "width_cm",
    label: "width_cm"
  },
  {
    key: "depth_cm",
    label: "depth_cm"
  },
  {
    key: "units_ctn",
    label: "units_ctn"
  },
  {
    key: "actual_weight_kg",
    label: "actual_weight_kg"
  },
  {
    key: "shipping_weight_kg",
    label: "shipping_weight_kg"
  },
  {
    key: "retail_price",
    label: "retail_price"
  },
  {
    key: "sale_price",
    label: "sale_price"
  },
  {
    key: "cost",
    label: "cost"
  },
  {
    key: "expiration_date",
    label: "expiration_date"
  },
  {
    key: "critical_threshold_fixed",
    label: "critical_threshold_fixed"
  },
  {
    key: "critical_threshold_variable",
    label: "critical_threshold_variable"
  },
  {
    key: "critical_threshold",
    label: "critical_threshold"
  },
  {
    key: "default_picking_location",
    label: "default_picking_location"
  },
  {
    key: "dg",
    label: "dg"
  },
  {
    key: "battery_magnets",
    label: "battery_magnets"
  },
  {
    key: "product_image_1",
    label: "product_image_1"
  },
  {
    key: "product_image_2",
    label: "product_image_2"
  },
  {
    key: "product_image_3",
    label: "product_image_3"
  },
  {
    key: "product_image_4",
    label: "product_image_4"
  },
  {
    key: "product_image_5",
    label: "product_image_5"
  },
  {
    key: "product_video",
    label: "product_video"
  },
  {
    key: "flag_1",
    label: "flag_1"
  },
  {
    key: "flag_2",
    label: "flag_2"
  },
  {
    key: "flag_3",
    label: "flag_3"
  },
  {
    key: "flag_4",
    label: "flag_4"
  },
  {
    key: "flag_5",
    label: "flag_5"
  },
  {
    key: "flag_6",
    label: "flag_6"
  },
  {
    key: "flag_7",
    label: "flag_7"
  },
  {
    key: "flag_8",
    label: "flag_8"
  },
  {
    key: "flag_9",
    label: "flag_9"
  },
  {
    key: "flag_10",
    label: "flag_10"
  }
];

const fields = [
  {
    key: "chk_box",
    label: ""
  },
  // {
  //   key: "client",
  //   label: "Client"
  // },
  {
    key: "channel",
    label: "Channel"
  },
  {
    key: "primary_category",
    label: "Primary Category"
  },
  {
    key: "product_sku",
    label: "Product SKU"
  },
  {
    key: "other_sku",
    label: "Other SKU"
  },
  {
    key: "channel_sku",
    label: "Channel SKU"
  },
  {
    key: "lot_1",
    label: "Lot 1",
    class: "center_align"
  },
  {
    key: "vendor",
    label: "Vendor"
  },
  {
    key: "brand",
    label: "Brand"
  },
  {
    key: "product_description_en",
    label: "Item Description"
  },
  {
    key: "expiration_date",
    label: "Expiration Date"
  },
  {
    key: "default_picking_location",
    label: "Default Picking Location"
  },
  {
    key: "action",
    label: "Action"
  },
];

import apiService from "../services/ApiService";
import global_function from "../mixins/global_function";
export default {
  name: "ProductMaster",
  inject: ["API_HOST", "TABLE_LIMIT", "PAGING_LIMIT", "NODEJS_API_URL"],
  components: {
    barcode: VueBarcode
  },
  mixins: [apiService, global_function],
  data() {
    return {
      upload_file: [],
      upload_file_serial: [],
      upload_file_bulk_fulfil_serial: [],
      loader: false,
      items: [],
      fields: fields,
      currentPage: 1,
      table_offset: 0,
      total_rows: 0,
      search_criteria: {
        keyword: "",
        channel_selected: null
      },
      channel_options: [
        {
          text: 'All Channel',
          value: null
        }
      ],
      check_all_rows: false
    };
  },
  async created() {
    await this.getProductMaster();
    let channels_response = await this.getChannels(this.$store.state.user_obj);
    for (let i in channels_response.channels) {
      this.channel_options.push({
        value: channels_response.channels[i].name,
        text: channels_response.channels[i].name
      });
    }
    this.initialized = true;
  },
  mounted() {
    this.loader = this.$loading.show({
      isFullPage: true,
      canCancel: false
    });
  },
  watch: {
    // whenever changes, this function will run
    check_all_rows: function (new_val, old_val) {
      if (new_val == "all") {
        // Check all
        for (let i in this.items) {
          this.items[i].is_checked = true;
        }
      } else {
        for (let i in this.items) {
          this.items[i].is_checked = false;
        }
      }
    }
  },
  methods: {
    displayDate(d) {
      if (d) {
        return moment(d).format("YYYY-MM-DD");
      } else {
        return "/";
      }
    },

    async getProductMaster() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "product_master_get.php",
        data: {
          offset: this.table_offset,
          limit: this.TABLE_LIMIT,
          search_criteria: this.search_criteria,
          client_id: this.$store.state.user_obj.client_id
        }
      });
      this.items = response.data.products;
      this.total_rows = parseInt(response.data.total_rows);
      this.loader.hide();
    },

    onSearch() {
      this.getProductMaster();
    },

    onPageChange(page_to_change) {
      this.table_offset = (page_to_change - 1) * this.TABLE_LIMIT;
      this.getProductMaster();
    },

    async onUploadFile() {
      this.loader = this.$loading.show({
        isFullPage: true,
        canCancel: false
      });

      let formData = new FormData();
      formData.append("excel_file", this.upload_file);
      formData.append("client_id", this.$store.state.user_obj.client_id);
      formData.append("user_id", this.$store.state.user_obj.user_id);

      try {
        let response = await this.$http({
          method: "POST",
          baseURL: `${this.API_HOST}`,
          url: "product_master_import.php",
          headers: {
            "Content-Type": "multipart/form-data"
          },
          data: formData
        });

        this.loader.hide();

        if (!response || !response.data) {
          this.$eventHub.$emit("show_modal_message", {
            message_content: "Upload Failed: No response from server.",
            message_type: "error"
          });
          return;
        }

        if (response.data.status === "fail" || response.data.status === "error") {
          this.$eventHub.$emit("show_modal_message", {
            message_content: response.data.error_msg || response.data.message || "Upload Failed.",
            message_type: "error"
          });
          return;
        }

        this.$eventHub.$emit("show_modal_message", {
          message_content: "Upload Success"
        });

        this.getProductMaster();

      } catch (error) {
        this.loader.hide();

        let errorMsg = "Upload Failed.";

        if (error.response && error.response.data) {
          errorMsg =
            error.response.data.error_msg ||
            error.response.data.message ||
            error.message;
        } else if (error.message) {
          errorMsg = error.message;
        }

        this.$eventHub.$emit("show_modal_message", {
          message_content: errorMsg,
          message_type: "error"
        });
      }
    },

    async onUploadFile_serial() {
      this.loader = this.$loading.show({
        isFullPage: true,
        canCancel: false
      });

      let formData = new FormData();
      formData.append("excel_file", this.upload_file_serial);
      formData.append("client_id", this.$store.state.user_obj.client_id);
      formData.append("user_id", this.$store.state.user_obj.user_id);

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "product_serial_import.php",
        headers: {
          "Content-Type": "multipart/form-data"
        },
        data: formData
      });

      if (response) {
        this.loader.hide();
        this.$eventHub.$emit("show_modal_message", {
          message_content: 'Upload Success'
        });
        this.getProductMaster();
        // window.location.reload();
      }
    },

    async onUploadFile_bulk_fulfil_serial() {
      this.loader = this.$loading.show({
        isFullPage: true,
        canCancel: false
      });

      let formData = new FormData();
      formData.append("excel_file", this.upload_file_bulk_fulfil_serial);
      formData.append("client_id", this.$store.state.user_obj.client_id);
      formData.append("user_id", this.$store.state.user_obj.user_id);

      try {
        let response = await this.$http({
          method: "POST",
          baseURL: `${this.API_HOST}`,
          url: "product_serial_bulk_fulfil.php",
          headers: {
            "Content-Type": "multipart/form-data"
          },
          data: formData
        });

        if (response && response.data.status === 'error') {
          this.loader.hide();

          const details = Object.entries(response.data.invalid_serials)
            .map(([serial, reason]) => `${serial}: ${reason}`)
            .join('\n');

          this.$eventHub.$emit("show_modal_message", {
            message_content: `❌ Upload Failed:\n${response.data.message}\n\n${details}`,
            message_type: 'error'
          });

          return;
        }

        this.loader.hide();
        this.$eventHub.$emit("show_modal_message", {
          message_content: 'Upload Success'
        });
        this.getProductMaster();
      } catch (error) {
        this.loader.hide();
        this.$eventHub.$emit("show_modal_message", {
          message_content: `Upload Failed: ${error.message}`,
          message_type: 'error'
        });
      }
    },

    onExport() {

      this.loader = this.$loading.show({
        isFullPage: true,
        canCancel: false
      });

      this.$http({
        url:
          this.NODEJS_API_URL + "/gen_excel",
        method: "POST",
        data: {
          "export_type": "sku_master",
          limit: 999999,
          search_criteria: this.search_criteria,
          client_id: this.$store.state.user_obj.client_id
        },
        responseType: "blob" // important
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "sku_master.xlsx");
        document.body.appendChild(link);
        link.click();

        this.loader.hide();
      });
    },

    onExportClientSKUMaster() {

      this.loader = this.$loading.show({
        isFullPage: true,
        canCancel: false
      });

      this.$http({
        url:
          this.NODEJS_API_URL + "/gen_excel",
        method: "POST",
        data: {
          "export_type": "client_sku_master",
          limit: 999999,
          search_criteria: this.search_criteria,
          client_id: this.$store.state.user_obj.client_id
        },
        responseType: "blob" // important
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "client_sku_master.xlsx");
        document.body.appendChild(link);
        link.click();

        this.loader.hide();
      });
    },
  }
};
</script>

<style>
th,
td {
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/ProductMaster.vue